/** @format */
import { IconSize } from '@mpb-com/feather/components/atoms/icon';
import React, { ForwardRefRenderFunction, Ref, forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import { GridRepeater } from '@toucan/client/shared/components/grid-repeater';
import { IconListItemSkeleton } from '@toucan/client/shared/components/icon-list-item';

import { StyledProductBox } from './index';
import { ProductBoxSkeletonProps } from './types';

export const defaultTestId = 'product-box-skeleton';

export const ProductBoxSkeletonWithRef: ForwardRefRenderFunction<
    HTMLElement,
    ProductBoxSkeletonProps
> = (
    {
        'data-testid': dataTestId = defaultTestId,
        isCollapsable = false,
        maxItemsPerColumn = 10,
        columns = 1,
        ...otherProps
    }: ProductBoxSkeletonProps,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    ref: Ref<any> | null | undefined
) => {
    const lineCount = isCollapsable ? 0 : maxItemsPerColumn;

    const renderItems = () =>
        Array(lineCount)
            .fill(null)
            .map(() => (
                <IconListItemSkeleton
                    key={uuid()}
                    size={IconSize.XS}
                    data-testid={`${dataTestId}__list-item`}
                />
            ));

    const renderColumns = () =>
        Array(columns)
            .fill(null)
            .map(() => (
                <ul key={uuid()} className="list">
                    {renderItems()}
                </ul>
            ));

    return (
        <StyledProductBox
            {...otherProps}
            ref={ref}
            data-testid={dataTestId}
            isCollapsable={isCollapsable}
        >
            <GridRepeater gridColumns={columns} className="list-container">
                {renderColumns()}
            </GridRepeater>
        </StyledProductBox>
    );
};

export const ProductBoxSkeleton = forwardRef(ProductBoxSkeletonWithRef);
